import { GlobalArea } from '@libs/templates/global-area';
import { ErrorBoundary } from '@libs/templates/template-pages';
import { BackDropSpinnerProvider } from '@ps-smart-cp/ppfw-client';
import { Outlet, Route } from 'react-router';

export const userRouter = (
  <Route
    path="/user"
    element={
      <BackDropSpinnerProvider>
        <GlobalArea isUnderSubsystem={false} />
        <Outlet />
      </BackDropSpinnerProvider>
    }
    errorElement={<ErrorBoundary isUnderSubsystem={false} />}
  >
    <Route path="change-password" lazy={async () => import('./pages/ChangePassword')} />
    <Route path="mfa-setting/*" lazy={async () => import('./pages/MfaSettingIndex')} />
    <Route path="webhook-token/*" lazy={async () => import('./pages/WebhookTokenIndex')} />
    <Route path="*" lazy={async () => import('@libs/templates/template-pages/NotFound')} />
  </Route>
);
